import {SubscriptionPlan} from '@/generated/graphql';
import {PageForType} from '../../types/page';
import {Loading} from '../loading/loading';

interface ComponentLoaderProps {
    pageFor?: PageForType | null;
    subscriptionPlans?: SubscriptionPlan[] | null;
    countryCode?: string | null;
    Component: React.ComponentType<{
        pageFor: PageForType;
        subscriptionPlans?: SubscriptionPlan[] | null;
        countryCode?: string | null;
    }>;
}

function ComponentLoader({
    pageFor,
    subscriptionPlans,
    countryCode,
    Component,
}: ComponentLoaderProps) {
    if (!pageFor) {
        return <Loading />;
    }

    return (
        <Component
            pageFor={pageFor}
            subscriptionPlans={subscriptionPlans}
            countryCode={countryCode}
        />
    );
}

export {ComponentLoader};
